// Module
var code = "<div> <div class=\"tooltip-title\" translate=\"title_noDefined_applications\"></div> <div translate=\"detail_noAppInPolicyTooltip_updatePolicy\"></div> </div> ";
// Exports
var _module_exports =code;;
var path = '/components/remediation-policy/tooltip-not-defined.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;